import { ReactElement } from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import DefaultObjects from '../../types/DefaultObjects';
import Org from '../../types/Org';
import DefaultEventSettingsEditor from '../common/DefaultEventSettingsEditor';

import OrgSeasonMonthDaysEditor from './OrgSeasonMonthDaysEditor';

interface OrgDefaultsEditorProps {
  org: Org;
  onUpdate: <K extends keyof Org>(field: K, value: Org[K]) => void;
}

export default function OrgDefaultsEditor(props: OrgDefaultsEditorProps): ReactElement {
  const { org, onUpdate } = props;

  return (
    <Stack spacing={2}>
      <Typography variant="body2" sx={{
        color: "text.secondary"
      }}>
        Set default values for leagues and events created within this organization.
      </Typography>
      <OrgSeasonMonthDaysEditor
        label={`Default annual season${(org.defaultSeasonMonthDays?.length ?? 0) > 1 ? 's' : ''}`}
        value={org.defaultSeasonMonthDays ?? DefaultObjects.Org.defaultSeasonMonthDays ?? []}
        onChange={(defaultSeasonMonthDays) => onUpdate('defaultSeasonMonthDays', defaultSeasonMonthDays)}
      />
      <DefaultEventSettingsEditor
        settings={{
          defaultPlayDays: org.defaultPlayDays,
          defaultEventSignupOpensDaysPrior: org.defaultEventSignupOpensDaysPrior,
          defaultEventSignupClosesDaysPrior: org.defaultEventSignupClosesDaysPrior,
          defaultCoursePair: org.defaultCoursePair,
          defaultStartTime: org.defaultStartTime,
          defaultMaxPlayers: org.defaultMaxPlayers,
          defaultSignupPriority: org.defaultSignupPriority,
          defaultGhinIndexSetDaysPrior: org.defaultGhinIndexSetDaysPrior,
          defaultNumTeamsInMatch: org.defaultNumTeamsInMatch,
          defaultTeamSize: org.defaultTeamSize,
          defaultTeeSheetGroupSize: org.defaultTeeSheetGroupSize,
          defaultShowRosterToAllDaysPrior: org.defaultShowRosterToAllDaysPrior,
          defaultShowRosterToTeamDaysPrior: org.defaultShowRosterToTeamDaysPrior,
        }}
        onChange={(field, value) => onUpdate(field, value as Org[typeof field])}
        isOrgLevel={true}
      />
    </Stack>
  );
}
